import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';
import { G_LIST_ITEM__node_neighbours } from './G_LIST_ITEM__node_neighbours';

interface PROPS {
  title: string;
  nodes_list: INVOCATION__base[];
}

export function G_LIST__node_neighbours({ title, nodes_list }: PROPS) {
  if (nodes_list.length === 0) return null;

  /*
   * HTML
   */

  return (
    <div className="flex flex-col gap-y-1 mb-3 px-2 min-h-0">
      <div className="text-xs text-bar-foreground p-1">{title}</div>
      {nodes_list.map(node => (
        <G_LIST_ITEM__node_neighbours key={node.meta.node_id} {...{ node }} />
      ))}
    </div>
  );
}
